import React from "react"
import { Heading, Spinner, Body } from "@walmart-web/livingdesign-components"
import { concatClassNames } from "helpers/jsxHelpers"
import { FormattedMessage, IntlShape } from "react-intl"
import "./index.scss"
import { capitalize } from "helpers/text"

interface TitleProps {
	title: string | undefined
	isDisabled?: boolean
	capitalizeFirst?: boolean | undefined
}

interface LoadingProps {
	intl: IntlShape
	title: string
}

interface DisabledProps {
	intl: IntlShape
	title?: string
}

const Title: React.FC<TitleProps> = ({ title, isDisabled, capitalizeFirst }) =>
	title ? (
		<Heading
			as="h5"
			data-testid={`title-${title}`}
			UNSAFE_className={concatClassNames([
				"filters-select-title",
				isDisabled && "disabled",
			])}
		>
			{GetTitle(capitalizeFirst, title)}
		</Heading>
	) : (
		<React.Fragment />
	)

const GetTitle = (capitalFirst: boolean | undefined, title: string) => {
	return capitalFirst == true ? title : capitalize(title)
}

const Loading: React.FC<LoadingProps> = ({ intl, title }) => (
	<div className="filters-select-loading">
		<Spinner size="small" />
		<div className="filters-select-loading-text">
			<FormattedMessage
				id="phronesis.filter.loading"
				values={{
					filter: intl.formatMessage({ id: title }).toLowerCase(),
				}}
			/>
		</div>
	</div>
)

const Disabled: React.FC<DisabledProps> = ({ intl, title }) => (
	<Body as="p" UNSAFE_className="disabled">
		{intl.formatMessage(
			{ id: "phronesis.filters.disabled" },
			{ disabledFilter: intl.formatMessage({ id: title }) }
		)}
	</Body>
)

export { Title, Loading, Disabled }
